module.exports = __webpack_public_path__ + "img/img_app_download_hover.734ce13f.svg";